import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=2879c8e8&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=2879c8e8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879c8e8",
  null
  
)

export default component.exports